var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.repairImageModal)?_c('div',[_c('h5',[_vm._v("Repair photo")]),_c('img',{staticClass:"img-damage img-thumbnail",attrs:{"src":_vm.repairImageModal || 'img/image_not_found.png',"alt":"damage"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }